<!--
/**
 * OrangeHRM Telegram Integration page
 */
 -->

<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        Telegram Integration
      </oxd-text>
      <oxd-divider />

      <oxd-form :loading="isLoading">
        <oxd-form-row>
          <oxd-text v-if="linked" tag="p">
            Linked Telegram:
            <strong>@{{ telegramUsername || chatId }}</strong>
          </oxd-text>
          <oxd-text v-else tag="p">
            Not linked yet. Generate a link code, then open the Telegram link
            (or send <code>/start CODE</code> to @{{ botUsername }}).
          </oxd-text>
        </oxd-form-row>

        <oxd-form-row v-if="deepLink">
          <oxd-text tag="p">
            Code: <strong>{{ linkCode }}</strong> (valid 15 minutes)
          </oxd-text>
          <oxd-text tag="p">
            <a :href="deepLink" target="_blank" rel="noopener">{{
              deepLink
            }}</a>
          </oxd-text>
        </oxd-form-row>

        <oxd-divider />
        <oxd-form-actions>
          <oxd-button
            display-type="secondary"
            label="Refresh Status"
            @click="load"
          />
          <oxd-button
            display-type="main"
            label="Generate Link"
            @click="generateLink"
          />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';

export default {
  name: 'TelegramIntegration',
  props: {
    empNumber: {
      type: Number,
      required: false,
      default: null,
    },
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      'api/v2/telegram/registration',
    );
    const linkHttp = new APIService(
      window.appGlobal.baseUrl,
      'api/v2/telegram/registration/generate-link',
    );
    return {http, linkHttp};
  },
  data() {
    return {
      isLoading: false,
      linked: false,
      chatId: '',
      telegramUsername: '',
      linkCode: '',
      deepLink: '',
      botUsername: 'REDIM_HRM_BOT',
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.isLoading = true;
      this.http
        .request({method: 'GET'})
        .then((response) => {
          const data = response.data?.data || {};
          this.linked = !!data.linked;
          this.chatId = data.chatId || '';
          this.telegramUsername = data.telegramUsername || '';
          this.linkCode = data.linkCode || '';
          this.deepLink = data.deepLink || '';
          this.botUsername = data.botUsername || 'REDIM_HRM_BOT';
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    generateLink() {
      this.isLoading = true;
      this.linkHttp
        .create({})
        .then((response) => {
          const data = response.data?.data || {};
          this.linkCode = data.linkCode || '';
          this.deepLink = data.deepLink || '';
          this.botUsername = data.botUsername || this.botUsername;
          this.$toast.saveSuccess({
            title: 'Success',
            message: 'Link code generated. Open the Telegram link.',
          });
        })
        .catch(() => {
          this.$toast.error({
            title: 'Error',
            message: 'Failed to generate Telegram link code',
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.load();
        });
    },
  },
};
</script>
